import type { AxiosInstance } from 'axios';
import type { MessageTestingRequest } from '../types/message-testing.js';

export class MessageTestingClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  startRun = async (data: MessageTestingRequest): Promise<{ runIdentifier: string }> => {
    const res = await this.authenticatedClient.post<{ runIdentifier: string }>('/message-testing', data);
    return res.data;
  };

  exportPpt = async (runIdentifier: string): Promise<Blob> => {
    const res = await this.authenticatedClient.post<Blob>(
      `/message-testing/${runIdentifier}/export-ppt`,
      undefined,
      { responseType: 'blob' }
    );
    return res.data;
  };
}
